import {
  VuexModule, Module, Action, getModule, MutationAction,
} from 'vuex-module-decorators';

import store from '@/store';

import {
  ICourseModalState,
  CurrentCourseForModalType,
  CurrentListForModalType,
} from '@/types/courses/CourseModal';

@Module({ store, name: 'courseModal', dynamic: true })
class CourseModal extends VuexModule implements ICourseModalState {
  /* eslint no-unused-expressions: ["error", { "allowTernary": true }] */
  currentCourse = {} as CurrentCourseForModalType;

  courseListForModal = [] as CurrentListForModalType;

  currentIndex = 0;

  @MutationAction({ mutate: ['currentIndex'] })
  async UPDATE_CURRENT_COURSE_INDEX(currentIndex?: number) {
    return { currentIndex: currentIndex || 0 };
  }

  @MutationAction({ mutate: ['currentCourse'] })
  async UPDATE_CURRENT_COURSE(currentCourse?: CurrentCourseForModalType) {
    return { currentCourse: currentCourse || {} };
  }

  @MutationAction({ mutate: ['courseListForModal'] })
  async UPDATE_CURRENT_COURSES_LIST(courseListForModal?: CurrentListForModalType) {
    return { courseListForModal: courseListForModal || [] };
  }

  @Action
  async SHOW_NEXT_COURSE() {
    if (this.currentIndex + 1 === this.courseListForModal.length) {
      this.UPDATE_CURRENT_COURSE(this.courseListForModal[0]);
      await this.UPDATE_CURRENT_COURSE_INDEX(0);
    } else {
      this.UPDATE_CURRENT_COURSE(this.courseListForModal[this.currentIndex + 1]);
      await this.UPDATE_CURRENT_COURSE_INDEX(this.currentIndex + 1);
    }
  }

  @Action
  async SHOW_PREV_COURSE() {
    if (this.currentIndex === 0) {
      this.UPDATE_CURRENT_COURSE(this.courseListForModal[this.courseListForModal.length - 1]);
      await this.UPDATE_CURRENT_COURSE_INDEX(this.courseListForModal.length - 1);
    } else {
      this.UPDATE_CURRENT_COURSE(this.courseListForModal[this.currentIndex - 1]);
      await this.UPDATE_CURRENT_COURSE_INDEX(this.currentIndex - 1);
    }
  }
}

export const CourseModalModule = getModule(CourseModal);
